import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';
import { pushTokenRegisterPublic } from '../crud/PushTokenCrud';

const useRegisterPushPublic = () => {
    const navigate = useNavigate()

    const handleRegister = (async () => {
        if (!Capacitor.isNativePlatform()) return;
        const perm = await PushNotifications.requestPermissions();
        if (perm.receive !== 'granted') return;

        await PushNotifications.register();

        PushNotifications.addListener('registration', async (token) => {
            console.log('FCM Token:', token.value);
            // Send token to backend
            let param = {
                token: token.value
            }
            await pushTokenRegisterPublic(param)
        });

        PushNotifications.addListener(
            'pushNotificationActionPerformed',
            (notification) => {
                const route = notification.notification.data?.route;
                if (route) {
                    navigate(route)
                }
            }
        );
    })
    return {
        handleRegister
    }
}

export default useRegisterPushPublic